export default __webpack_public_path__ + "static/media/logos-footer.a96edabb.png";